import React from 'react';
import ImageDropzone from './ImageDropzone';

const DropzoneVideo = ({ onDropHandler }) => (
  <ImageDropzone
    inputName="thumbnailImage"
    alt="Thumbnail"
    onImageReady={onDropHandler}
    prepareOptions={{ maxSize: 700 }}
    emptyPrompt="Drag and drop thumbnail here"
    showUploadButton
  />
);

export default DropzoneVideo;
